import React from 'react';

export function ChartContainer({ config, className = '', children, ...props }) {
  return (
    <div className={className} data-chart-config={JSON.stringify(config)} {...props}>
      {children}
    </div>
  );
}